import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RequestCodeComponent } from '../pages/request-code/request-code.component';
import { SignInComponent } from '../pages/sign-in/sign-in.component';
import { GardenSelectComponent } from '../pages/garden-select/garden-select.component';

const routes: Routes = [
  {
    path: '',
    component: RequestCodeComponent,
  },
  {
    path: 'sign-in',
    component: SignInComponent,
  },
  {
    path: 'garden-select',
    component: GardenSelectComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
